import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rt-icon-help',
  templateUrl: './icon-help.component.html',
  styleUrls: ['./icon-help.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconHelpComponent {}
